import { createAction } from "typesafe-actions"
import { AnalyticsActionTypes } from "@store/ducks/analytics/types"
import { TAnalyticsEvent } from "@services/analytics/definitions"

export const emitAnalyticsEvent = createAction(
	AnalyticsActionTypes.EmitAnalyticEvent,
	(event) => event
)<TAnalyticsEvent>()
